module.exports = __webpack_public_path__ + "static/media/topia-logo.9670d66e.svg";